exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:992px){.mb-errors[data-v-1a27e7fb]{margin-bottom:22px}}.uploaded-item[data-v-1a27e7fb]{text-align:center}.uploaded-item .uploaded-item__pdf[data-v-1a27e7fb]{width:180px}.uploaded-item .uploaded-item__img[data-v-1a27e7fb]{max-width:400px}.uploaded-item .uploaded-item__name[data-v-1a27e7fb]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
